import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { MetronicMaterialModule } from './metronic-material/metronic-material.module';

@NgModule({
  imports: [CommonModule, MetronicMaterialModule,AngularMaterialModule],
})
export class A2zLibModule {
  static configureEnvironment(env): ModuleWithProviders<A2zLibModule> {
    return {
      ngModule: A2zLibModule,
      providers: [{ provide: 'AppEnvironment', useValue: env }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: A2zLibModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
